// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { operatorId } from './Operator';
import { calendarDate } from '../../calendar-date';
import { analyticBiogenicAminesSampleTypeEnum } from './AnalyticBiogenicAminesSampleTypeEnum';
import { testInstanceId } from './TestInstance';
import { analyticBiogenicAminesKindEnum } from './AnalyticBiogenicAminesKindEnum';
import { calibrationCurveVersionId } from './CalibrationCurveVersion';
import { z } from 'zod';
export const analyticBiogenicAminesReportId = (z.number());
export const analyticBiogenicAminesReport = z.object({
    id: analyticBiogenicAminesReportId,
    sample_name: z.string(),
    analyst_id: operatorId,
    date_measured: calendarDate,
    date_received: calendarDate.nullable(),
    sampling_date: calendarDate.nullable(),
    matrix: z.string().nullable(),
    sample_type: analyticBiogenicAminesSampleTypeEnum,
    total_volume: z.string(),
    dry_matter: z.string(),
    amount_broth: z.string().nullable(),
    amount_powder: z.string().nullable(),
    put_area: z.string(),
    try_area: z.string(),
    put_conc: z.string(),
    try_conc: z.string(),
    put_mass_mg: z.string(),
    try_mass_mg: z.string(),
    put_mg_per_kg: z.string(),
    try_mg_per_kg: z.string(),
    file_path: z.string(),
    created_at: z.date(),
    updated_at: z.date(),
    created_by: operatorId.nullable(),
    last_updated_by: operatorId.nullable(),
    deleted_at: z.date().nullable(),
    deleted_by: operatorId.nullable(),
    test_instance_id: testInstanceId.nullable(),
    kind: analyticBiogenicAminesKindEnum,
    put_curve_version_id: calibrationCurveVersionId.nullable(),
    try_curve_version_id: calibrationCurveVersionId.nullable(),
});
export const analyticBiogenicAminesReportInitializer = z.object({
    id: analyticBiogenicAminesReportId.optional(),
    sample_name: z.string(),
    analyst_id: operatorId,
    date_measured: calendarDate,
    date_received: calendarDate.optional().nullable(),
    sampling_date: calendarDate.optional().nullable(),
    matrix: z.string().optional().nullable(),
    sample_type: analyticBiogenicAminesSampleTypeEnum,
    total_volume: z.string(),
    dry_matter: z.string(),
    amount_broth: z.string().optional().nullable(),
    amount_powder: z.string().optional().nullable(),
    put_area: z.string(),
    try_area: z.string(),
    put_conc: z.string(),
    try_conc: z.string(),
    put_mass_mg: z.string(),
    try_mass_mg: z.string(),
    put_mg_per_kg: z.string(),
    try_mg_per_kg: z.string(),
    file_path: z.string(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    test_instance_id: testInstanceId.optional().nullable(),
    kind: analyticBiogenicAminesKindEnum.optional(),
    put_curve_version_id: calibrationCurveVersionId.optional().nullable(),
    try_curve_version_id: calibrationCurveVersionId.optional().nullable(),
});
export const analyticBiogenicAminesReportMutator = z.object({
    id: analyticBiogenicAminesReportId.optional(),
    sample_name: z.string().optional(),
    analyst_id: operatorId.optional(),
    date_measured: calendarDate.optional(),
    date_received: calendarDate.optional().nullable(),
    sampling_date: calendarDate.optional().nullable(),
    matrix: z.string().optional().nullable(),
    sample_type: analyticBiogenicAminesSampleTypeEnum.optional(),
    total_volume: z.string().optional(),
    dry_matter: z.string().optional(),
    amount_broth: z.string().optional().nullable(),
    amount_powder: z.string().optional().nullable(),
    put_area: z.string().optional(),
    try_area: z.string().optional(),
    put_conc: z.string().optional(),
    try_conc: z.string().optional(),
    put_mass_mg: z.string().optional(),
    try_mass_mg: z.string().optional(),
    put_mg_per_kg: z.string().optional(),
    try_mg_per_kg: z.string().optional(),
    file_path: z.string().optional(),
    created_at: z.date().optional(),
    updated_at: z.date().optional(),
    created_by: operatorId.optional().nullable(),
    last_updated_by: operatorId.optional().nullable(),
    deleted_at: z.date().optional().nullable(),
    deleted_by: operatorId.optional().nullable(),
    test_instance_id: testInstanceId.optional().nullable(),
    kind: analyticBiogenicAminesKindEnum.optional(),
    put_curve_version_id: calibrationCurveVersionId.optional().nullable(),
    try_curve_version_id: calibrationCurveVersionId.optional().nullable(),
});
//# sourceMappingURL=AnalyticBiogenicAminesReport.js.map